/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface AcquisScolaireSearchDto
 */
export interface AcquisScolaireSearchDto {
    /**
     * 
     * @type {number}
     * @memberof AcquisScolaireSearchDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AcquisScolaireSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof AcquisScolaireSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof AcquisScolaireSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AcquisScolaireSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof AcquisScolaireSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AcquisScolaireSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the AcquisScolaireSearchDto interface.
 */
export function instanceOfAcquisScolaireSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AcquisScolaireSearchDtoFromJSON(json: any): AcquisScolaireSearchDto {
    return AcquisScolaireSearchDtoFromJSONTyped(json, false);
}

export function AcquisScolaireSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcquisScolaireSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function AcquisScolaireSearchDtoToJSON(value?: AcquisScolaireSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idpersonne': value.idpersonne,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

